import { colorPaletteValidNames } from "../../types";
export const getCurrentPalette = (palette) => {
    if (!palette || !colorPaletteValidNames.includes(palette)) {
        return "palette1";
    }
    return palette;
};
export const mixinSkins = (supportedSkins) => (props) => ({ theme: { skin: currentSkin, palette } }) => {
    const currentPalette = getCurrentPalette(props?.palette || palette);
    if (!currentSkin) {
        return "";
    }
    const selectedSkinFn = getSelectedSkin(supportedSkins, currentSkin);
    return selectedSkinFn?.(currentSkin, currentSkin.palettes?.[currentPalette]) || "";
};
function getSelectedSkin(supportedSkins, currentSkin) {
    const { skinId, parentSkinId } = currentSkin;
    const directSkin = supportedSkins[skinId];
    if (directSkin) {
        return directSkin;
    }
    const baseSkin = parentSkinId && supportedSkins[parentSkinId];
    if (baseSkin) {
        return baseSkin;
    }
    return undefined;
}
//# sourceMappingURL=themeStyles.js.map